<template>
  <BaseForm
    v-if="clientApp"
    ref="baseForm"
    :title="'Client Application'"
    :data-object="transformedClientApp"
    :content-type="'client-app'"
    :completed-location="completedLocation"
    class="client-app-form"
  >
    <template #content>
      <v-sheet>
        <v-text-field
          v-model.trim="clientApp.name"
          :disabled="loading"
          :loading="loading"
          placeholder="Name"
          label="Name"
          icon="text-short"
        />
        <v-text-field
          v-model="organisation.name"
          label="Organisation"
          disabled
          placeholder="Organisation"
          icon="text-short"
        />
      </v-sheet>

      <v-sheet>
        <v-select
          v-model="clientApp.view_id"
          :disabled="!isNew"
          icon="text-short"
          color="primary"
          label="Client App Type"
        >
          <option
            v-for="app in clientAppList()"
            :key="app.view_id"
            :modelValue="app.view_id"
          >
            {{ app.name }}
          </option>
        </v-select>

        <v-text-field
          v-model="clientApp.handle"
          :disabled="!isNew"
          label="Handle"
          s
          placeholder="Handle"
          icon="text-short"
        />
      </v-sheet>

      <v-sheet>
        <v-text-field
          v-model="clientApp.description"
          type="textarea"
          label="Description"
          color="primary"
        />
      </v-sheet>

      <ClientAppSettings v-if="id !== '0'" :client-app="id" />
    </template>
  </BaseForm>
</template>

<script setup lang="ts">
import { computed, onMounted, Ref, ref } from 'vue'
import { useRoute } from 'vue-router'
import { useStore } from 'vuex'

import { apiClient } from '@/api/ApiClient'
import { clientAppList } from '@/apps/clientAppRegistry'
import BaseForm from '@/components/common/BaseForm.vue'
import { ClientApp } from '@/models/client/models'
import { Organisation, ORGANISATION_DEFAULT } from '@/models/core/organisation'

import ClientAppSettings from './ClientAppSettings.vue'
const route = useRoute()
const store = useStore()

const props = defineProps({
  id: {
    required: true,
    type: String,
  },
})
const baseForm: Ref<typeof BaseForm> = ref(null)
const clientApp: Ref<ClientApp> = ref(null)
const loading: Ref<boolean> = ref(false)
const organisation: Ref<Organisation> = ref(
  JSON.parse(JSON.stringify(ORGANISATION_DEFAULT))
)

onMounted(() => {
  loading.value = true
  apiClient
    .get('client-app', props.id)
    .then((response) => {
      clientApp.value = response
      loading.value = false
      return clientApp.value.organisation
    })
    .then((response) => {
      let orgId = ''
      if (props.id === '0') {
        orgId = store.getters['global/object']('organisation').id
      } else {
        orgId = response
      }
      apiClient.get('organisation', orgId).then((organisation) => {
        organisation.value = organisation
      })
    })
})

const completedLocation = computed(() => {
  if (route.name === 'bootstrap-client-app-create') {
    return {
      name: 'organisation',
    }
  } else {
    return null
  }
})

const isNew = computed(() => {
  return props.id === '0'
})

const transformedClientApp = computed(() => {
  clientApp.value.organisation = organisation.value.id
  return clientApp.value
})
</script>
